import { Component, OnInit } from '@angular/core';
import { MobileNavService } from '../../shared/services/mobile-nav.service';
import { TimelineService } from '../shared/services/timeline.service';
import { AuthService } from '../../shared/services/auth/auth.service';
import { Configuration } from '../../app.constants';
import {Location} from '@angular/common';
import * as moment from 'moment';
import * as io from 'socket.io-client';
import { SocketService } from 'app/shared/services/socket.service';
@Component({
  selector: 'app-mobile-notifications',
  templateUrl: './mobile-notifications.component.html',
  styleUrls: ['./mobile-notifications.component.css']
})
export class MobileNotificationsComponent implements OnInit {

  public notifications= [];
  public socket: any;
  public socketnot: any;
  public serverApiUrl;
  constructor( public mobileNav: MobileNavService,
    public timelineService: TimelineService,
    public auth: AuthService,
    public _location: Location,
    public config: Configuration,
    private socketService:SocketService
    ) { }

  ngOnInit() {
    this.serverApiUrl = this.config.StaticImageUrl;
    // this.socketnot = io(this.config.SocketUrl);
    this.getAllNotifications();

    // this.socketListner();
  }

  socketListner(){
    this.socketService.notificationObs.subscribe(notification=>{
        if(notification !== undefined) {
            if (this.notifications[0].day!=='Today'){
                this.notifications.unshift({day:'Today',notifications:[]})
            }
            this.notifications[0].notifications.unshift(notification);
        }
    });
  }

  onClickMe() {
    this.mobileNav.showSideNav();
  }
  getAllNotifications(){
    var current=moment();
    var yesterday=moment().add('days',-1);

    this.timelineService.getAllNotifications(this.auth.user.associateId).subscribe(data1 => {
        var datas=Object.assign([],data1)
        console.log('NOtifications',datas);
        var obj={day:'',notifications:[]};
        datas.filter(data=>{
            if(current.format('DD MMM YYYY')===moment(data.time).format('DD MMM YYYY')){
                if(obj.day!=='Today'){
                    if(obj.notifications.length)
                        this.notifications.push(Object.assign({},obj))
                    obj.day='Today'
                    obj.notifications=[];
                    obj.notifications.push(data)
                }else    
                obj.notifications.push(data)
            }
            else if(yesterday.format('DD MMM YYYY')===moment(data.time).format('DD MMM YYYY')){
                if(obj.day!=='Yesterday'){
                    if(obj.notifications.length)
                        this.notifications.push(Object.assign({},obj))
                    obj.day='Yesterday'
                    obj.notifications=[];
                    obj.notifications.push(data)
                }
                else
                    obj.notifications.push(data)
            }
            else if(obj.day!==moment(data.time).format('DD MMM YYYY')){
                if(obj.notifications.length)
                    this.notifications.push(Object.assign({},obj))
                obj.day=moment(data.time).format('DD MMM YYYY')
                obj.notifications=[];
                obj.notifications.push(data)
            }
            else{
                obj.notifications.push(data)
            }
        })
        if ( obj.day) {
            this.notifications.push(Object.assign({}, obj))
        } else {
            this.notifications = [{day: 'Today', notifications: []}];
        }
        })

    // this.socketnot.on(`notifications-${this.auth.user.associateId}`, function (data) {
    //     if (this.notifications[0].day!=='Today')
    //         this.notifications.unshift({day:'Today',notifications:[]})
    //     this.notifications[0].notifications.unshift(data);
    // }.bind(this));
  

  }

  backBtnClick() {
    this._location.back();
  }

}
